import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from 'semantic-ui-react';
import { Box, Button, Flex } from 'theme-ui';
type footerProps = {
  handleCartAction: any;
  setIsLoadingCart: any;
  setIsLoadingPay: any;
  lessonTopic: any;
  lessonType: any;
  selectedSubject: any;
  selectedGrade: any;
  lessonFor: any;
  isLoadingCart: any;
  isLoadingPay: any;
  addToCart: any;
  onNext: any;
  timeAlreadyInCart: any;
  setTimeAlreadyInCart: any;
  errorMessage: any;
};

function BookALessonFooter({
  handleCartAction,
  setIsLoadingCart,
  setIsLoadingPay,
  lessonTopic,
  lessonType,
  selectedSubject,
  selectedGrade,
  lessonFor,
  isLoadingCart,
  isLoadingPay,
  addToCart,
  onNext,
  timeAlreadyInCart,
  setTimeAlreadyInCart,
  errorMessage,
}: footerProps) {
  const { t } = useTranslation();
  return (
    <div>
      {timeAlreadyInCart && (
        <Box
          sx={{ marginBottom: '24px' }}
          className="text-highlight--error--center"
        >
          {t('timeAlreadyInCart')}
        </Box>
      )}
      {errorMessage && (
        <Box
          sx={{ marginBottom: '24px' }}
          className="text-highlight--error--center"
        >
          {errorMessage}
        </Box>
      )}
      <Box>
        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            marginTop: 'auto',
            gap: '20px',
          }}
          className="book-a-lesson__footer"
        >
          <Button
            sx={{ flex: 1, fontFamily: 'Roboto' }}
            variant="inverted"
            type="button"
            disabled={isLoadingCart || isLoadingPay}
            onClick={() => {
              handleCartAction(
                (index) =>
                  addToCart({
                    topic: !index ? lessonTopic : t('checkBeforeLesson'),
                    selectedProductId: lessonType,
                    subject: selectedSubject,
                    grade: selectedGrade,
                    forUser: lessonFor,
                    loading: setIsLoadingCart,
                    timeAlreadyInCart: setTimeAlreadyInCart,
                  }),
                setIsLoadingCart,
                setTimeAlreadyInCart,
                false
              );
            }}
          >
            {isLoadingCart ? (
              <Loader inline active size="small" />
            ) : (
              t('addToCart')
            )}
          </Button>
          <Button
            disabled={isLoadingCart || isLoadingPay}
            type="button"
            onClick={() => {
              handleCartAction(
                (index) =>
                  onNext({
                    topic: !index ? lessonTopic : t('checkBeforeLesson'),
                    selectedProductId: lessonType,
                    subject: selectedSubject,
                    grade: selectedGrade,
                    forUser: lessonFor,
                    loading: setIsLoadingPay,
                    timeAlreadyInCart: setTimeAlreadyInCart,
                  }),
                setIsLoadingPay,
                setTimeAlreadyInCart,
                true
              );
            }}
            sx={{ flex: 1, fontFamily: 'Roboto' }}
          >
            {isLoadingPay ? (
              <Loader inline active size="small" inverted />
            ) : (
              t('pay')
            )}
          </Button>
        </Flex>
      </Box>
    </div>
  );
}

export default BookALessonFooter;
